import { Accordion, Box, Heading, Text } from "@chakra-ui/react";
import { DimensionGridAccordionItem } from "./index";
import * as React from "react";
import { useTranslation } from "react-i18next";
import ManualEmissionsList from "../../shared/ManualEmissionsList";

export const getFilledCategoriesArray = (data) => {
  return !data ? [] : Object.keys(data).filter(type => {
    // Guard data[type] itself: ESG-3927's `electricityV2` group is null when a
    // report has no v2 data, and a null group must not crash the filter.
    return data[type]?.items?.length > 0;
  });
};

function DimensionScopeSection({ title, data, manualEmissions, hasOtherData }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });

  const manualRows = manualEmissions ?? [];
  const hasManualRows = manualRows.length > 0;
  const hasActivity = getFilledCategoriesArray(data).length > 0;

  if (!hasActivity && !hasManualRows && !hasOtherData) return null;

  return (
    <Box border="1px solid" borderColor="gray.200" borderRadius="md" padding={4} marginBottom={5}>
      <Heading size="md" marginBlock="1">
        {title}
      </Heading>
      {hasActivity ?
        <Accordion defaultIndex={[0]} allowMultiple margin="20px 0">
          {Object.keys(data).map(emissionsKey => {
            return data[emissionsKey]?.items?.length > 0 ?
              <DimensionGridAccordionItem
                key={`dimension-accordion-item-${emissionsKey}`}
                data={data}
                titleKey={`${emissionsKey}Title`}
                type={emissionsKey}
              /> : null;
          })}
        </Accordion> :
        !hasManualRows && <Text fontSize="lg" fontWeight="bold">
          {t("scope1&2.dimension.noFilteredData")}
        </Text>
      }
      <ManualEmissionsList items={manualRows} />
    </Box>
  );
}

export default DimensionScopeSection;